import type { Enums } from "../types";

/**
 * This function is used to get the color associated with a project invoice state.
 * It returns a color based on the state of the invoice.
 * @param state
 * @returns
 */
export function getProjectInvoiceStateColor(state: Enums<"outgoingInvoiceState">): Enums<"color"> {
	switch (state) {
		case "paid":
			return "emerald";
		case "pending":
			return "primary";
		case "overdue":
			return "red";
	}
}
